import { useTranslation } from "react-i18next";
import { useWatch } from "react-hook-form";
import IntakeTextField from "../../../components/Form/IntakeTextField";
import {
  ENTERPRISE_INTAKE_FIELD_COMPANY_NAME,
  ENTERPRISE_INTAKE_FIELD_CORPORATE_EMAIL,
  ENTERPRISE_INTAKE_FIELD_FULL_NAME,
  ENTERPRISE_INTAKE_FIELD_JOB_TITLE,
  ENTERPRISE_INTAKE_PLACEHOLDER_COMPANY_NAME,
  ENTERPRISE_INTAKE_PLACEHOLDER_COMPANY_NAME_BRAND,
  ENTERPRISE_INTAKE_PLACEHOLDER_CORPORATE_EMAIL,
  ENTERPRISE_INTAKE_PLACEHOLDER_FULL_NAME,
  ENTERPRISE_INTAKE_PLACEHOLDER_JOB_TITLE,
} from "../../../i18n/keysTranslations";
import FieldBlock from "../../PreActivation/components/FieldBlock";
import FieldLabel from "../../PreActivation/components/FieldLabel";
import ReadOnlySectionGrid from "../../PreActivation/components/ReadOnlySectionGrid";
import { ENTERPRISE_INTAKE_ORGANIZATION_TYPE_BRAND } from "../enterpriseIntakeFormValues";

const ContactSection = ({ control, errors, readOnly }) => {
  const { t } = useTranslation();
  const organizationType = useWatch({ control, name: "organizationType" });
  const companyPlaceholder =
    organizationType === ENTERPRISE_INTAKE_ORGANIZATION_TYPE_BRAND
      ? t(ENTERPRISE_INTAKE_PLACEHOLDER_COMPANY_NAME_BRAND)
      : t(ENTERPRISE_INTAKE_PLACEHOLDER_COMPANY_NAME);

  return (
    <ReadOnlySectionGrid readOnly={readOnly}>
      <FieldBlock>
        <FieldLabel
          htmlFor="fullName"
          text={t(ENTERPRISE_INTAKE_FIELD_FULL_NAME)}
          required
        />
        <IntakeTextField
          name="fullName"
          control={control}
          rules={{}}
          errors={errors}
          fullWidth
          readOnly={readOnly}
          placeholder={t(ENTERPRISE_INTAKE_PLACEHOLDER_FULL_NAME)}
          variant="outlined"
        />
      </FieldBlock>

      <FieldBlock>
        <FieldLabel
          htmlFor="corporateEmail"
          text={t(ENTERPRISE_INTAKE_FIELD_CORPORATE_EMAIL)}
          required
        />
        <IntakeTextField
          name="corporateEmail"
          control={control}
          rules={{}}
          errors={errors}
          fullWidth
          readOnly={readOnly}
          placeholder={t(ENTERPRISE_INTAKE_PLACEHOLDER_CORPORATE_EMAIL)}
          variant="outlined"
        />
      </FieldBlock>

      <FieldBlock>
        <FieldLabel
          htmlFor="companyName"
          text={t(ENTERPRISE_INTAKE_FIELD_COMPANY_NAME)}
          required
        />
        <IntakeTextField
          name="companyName"
          control={control}
          rules={{}}
          errors={errors}
          fullWidth
          readOnly={readOnly}
          placeholder={companyPlaceholder}
          variant="outlined"
        />
      </FieldBlock>

      <FieldBlock>
        <FieldLabel
          htmlFor="jobTitle"
          text={t(ENTERPRISE_INTAKE_FIELD_JOB_TITLE)}
          required
        />
        <IntakeTextField
          name="jobTitle"
          control={control}
          rules={{}}
          errors={errors}
          fullWidth
          readOnly={readOnly}
          placeholder={t(ENTERPRISE_INTAKE_PLACEHOLDER_JOB_TITLE)}
          variant="outlined"
        />
      </FieldBlock>
    </ReadOnlySectionGrid>
  );
};

export default ContactSection;
